import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {HomeRoutes} from '@app/routes/home.routes';
import {MyTeamsPageComponent} from '@shared/components/team/my-teams-page/my-teams-page.component';
import {ShopComponent} from '@modules/shop/components/shop.component';
import {MatchRoutePaths} from '@lib-modules/match/match-route-paths';
import { USER_CONTEXT } from '../../../../projects/shared/utils/src/lib/context/user-context';
import { UserService } from '../../core/services/user.service';

export const routes: Routes = [
  {
    path: HomeRoutes.abo.index,
    loadChildren: () =>
      import('@modules/subscription/subscription.module').then(
        (m) => m.SubscriptionModule
      ),
  },
  {
    path: HomeRoutes.community,
    loadChildren: () =>
      import('@modules/home/community/community.module').then(
        (m) => m.CommunityModule
      ),
  },
  {
    path: HomeRoutes.news.root,
    loadChildren: () =>
      import('@modules/home/tabs/news/news.module').then((m) => m.NewsModule),
  },
  {
    path: HomeRoutes.news.root,
    loadChildren: () =>
      import('@modules/home/tabs/news/news.module').then((m) => m.NewsModule),
  },
  {
    path: MatchRoutePaths.root.default,
    loadChildren: () =>
      import('@lib-modules/match/lib-match.module').then(
        (m) => m.LibMatchModule
      ),
  },
  {
    path: HomeRoutes.games.root,
    loadChildren: () =>
      import('./tabs/games/games.module').then((m) => m.GamesModule),
  },
  {
    path: HomeRoutes.games.rootPersonal,
    loadChildren: () =>
      import('./tabs/games/games.module').then((m) => m.GamesModule),
  },
  {
    path: HomeRoutes.videos.root,
    loadChildren: () =>
      import('@modules/videos/videos.module').then((m) => m.VideosModule),
  },
  {
    path: HomeRoutes.handball.hla,
    redirectTo: HomeRoutes.handball.relative.videos,
    pathMatch: 'full',
  },
  {
    path: HomeRoutes.handball.wha,
    redirectTo: HomeRoutes.handball.relative.videos,
    pathMatch: 'full',
  },
  {
    path: HomeRoutes.handball.root,
    redirectTo: HomeRoutes.handball.relative.videos,
    pathMatch: 'full',
  },
  {
    path: HomeRoutes.handball.hla + '/downloads',
    redirectTo: HomeRoutes.handball.relative.downloads,
    pathMatch: 'full',
  },
  {
    path: HomeRoutes.handball.relative.downloads,
    loadChildren: () =>
      import('@modules/handball/handball.module').then((m) => m.HandballModule),
  },
  {
    path: HomeRoutes.handball.relative.videos,
    loadChildren: () =>
      import('@modules/videos/videos.module').then((m) => m.VideosModule),
  },
  {
    path: HomeRoutes.shop, component: ShopComponent,
    loadChildren: () =>
      import('@modules/shop/shop.module').then((m) => m.ShopModule),
  },
  {path: HomeRoutes.favourites, component: MyTeamsPageComponent},
  {path: HomeRoutes.favouriteWithState, component: MyTeamsPageComponent},
  {
    path: HomeRoutes.clubRegistration,
    loadChildren: () =>
      import('./club-registration/club-registration.module').then(
        (m) => m.ClubRegistrationModule
      ),
  },
  {
    path: HomeRoutes.teamOfTheRound.shortLink,
    redirectTo: HomeRoutes.teamOfTheRound.index,
  },
  {
    path: HomeRoutes.teamOfTheRound.index,
    loadChildren: () =>
      import('./team-of-the-round/team-of-the-round.module').then(
        (m) => m.TeamOfTheRoundModule
      ),
  },
  {
    path: HomeRoutes.adventSpecialShortLink,
    redirectTo: HomeRoutes.adventSpecialNewsLink,
  },
  {
    path: HomeRoutes.playerOfTheSeasonHalfShortLink,
    redirectTo: HomeRoutes.playerOfTheSeasonHalfNewsLink,
  },
  {
    path: '',
    loadChildren: () =>
      import('./policies/policies.module').then((m) => m.PoliciesModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [
    {
      provide: USER_CONTEXT,
      useFactory: (userService: UserService) => ({ userSubject: userService.currentUserSubject }),
      deps: [UserService]
    }
  ]
})
export class HomeRouting {
}
